<script setup lang="ts">
import { AppLinkButton, AppMarkdownWrapper } from '@libs/ui';

import ActivityDescriptionMarkdownStyles from './ActivityDescriptionMarkdownStyles.vue';

interface ActivityMainDescriptionProps {
  description: string;
  buttonText: string;
}

const props = defineProps<ActivityMainDescriptionProps>();

interface ActivityMainDescriptionEmits {
  (eventName: 'toggleFullDescription'): void;
}

const emit = defineEmits<ActivityMainDescriptionEmits>();
</script>

<template>
  <div class="activity-main-description">
    <div class="title">
      {{ $t('planner.description') }}
    </div>
    <ActivityDescriptionMarkdownStyles :opening-paragraph="false">
      <AppMarkdownWrapper :source="props.description" />
    </ActivityDescriptionMarkdownStyles>
    <AppLinkButton
      :text="props.buttonText"
      size="small"
      @click="emit('toggleFullDescription')"
    />
  </div>
</template>

<style scoped lang="scss">
.activity-main-description {
  .title {
    color: var(--color-soft-black);
    @include font-label-xxl-light;
  }
}
</style>
